import { useTranslation } from "@pancakeswap/localization"
import {
    Balance, Box, Button,
    ButtonProps,
    ChevronDownIcon,
    ChevronUpIcon, Flex, FlexGap,
    QuestionHelper,
    Text,
    TooltipText,
    useMatchBreakpoints,
    useModal,
    useOnClickOutside,
    useTooltip
} from "@pancakeswap/uikit"
import { ADDRESS_ZERO, MaxUint128, NonfungiblePositionManager, Payments, Position, tickToPrice } from "@pancakeswap/v3-sdk"
import { ChartEntry, LiquidityChartRangeInput, ZOOM_LEVELS, ZoomLevels } from "@pancakeswap/widgets-internal"
import { CurrencyLogo, DoubleCurrencyLogo } from "components/Logo"
import { Bound } from "config/constants/types"
import { useCurrency } from "hooks/Tokens"
import { usePool } from "hooks/v3/usePools"
// import Link from "next/link"
import useAccountActiveChain from 'hooks/useAccountActiveChain'
import { useMulticallContract, usePointsFarmingContract, useV3NFTPositionManagerContract } from 'hooks/useContract'
import React, { useCallback, useEffect, useMemo, useState } from "react"
import styled from "styled-components"
import { Address, encodeFunctionData, formatEther } from 'viem'
import { useDensityChartData } from "views/AddLiquidityV3/hooks/useDensityChartData"
import { usePoolData } from "views/V3Info/hooks"
import { PositionData } from "views/V3Info/types"
// import EButton from 'components/EButton'
import TransactionConfirmationModal from "components/TransactionConfirmationModal"
import { PointsFarmingABI } from "config/abi/PointsFarming"
import useCatchTxError from "hooks/useCatchTxError"
import { tryParsePrice } from "hooks/v3/utils"
import { calculateGasMargin } from "utils"
import { usePublicClient, useWalletClient } from "wagmi"
import { useCurrentBlock } from "state/block/hooks"
import { REWARD_RATIO } from "config/constants"
import { PoolData } from "../hooks/usePools"
import DecreaseModal from "./DecreaseModal"
import IncreaseModal from "./IncreaseModal"
import StakeModal from "./StakeModal"
import UnstakeModal from "./UnstakeModal"

const Panel = styled.div`
    // border: 1px solid #403d3f;
    background: #FFFFFF0D;
    // box-shadow: #fff 0px 2px 20px;
    border-radius: 16px;
    margin-top: 12px;
    padding: 16px 20px;   
`

const Hr = styled.hr`
    margin-top: 16px;
    border-color: #70658730;
`

const FeeTier = styled(Text)`
    border: 2px solid ${({ theme }) => theme.colors.textSubtle};
    border-radius: 8px;
    padding: 3px 4px;
    font-size: 12px;
    font-weight: bold;
    line-height: 12px;
    opacity: 0.5;
`

const Mark = styled(Text)`
    border: 2px solid #2EBF43;
    color: #2EBF43;
    border-radius: 8px;
    padding: 3px 4px;
    font-size: 12px;
    font-weight: bold;
    line-height: 12px;
`

const InRange = styled(Text) <{ percent?: number }>`
    z-index: -1;
    border-radius: 8px;
    padding: 5px 5px;
    font-size: 12px;
    font-weight: bold;
    line-height: 12px;
    white-space: nowrap;
    position: relative;
    background: ${({ theme }) => theme.colors.textSubtle};
    color: ${({ theme }) => theme.colors.backgroundAlt};
    overflow: hidden;
    &::before {
        content: '';
        position: absolute;
        background: #2EBF43;
        left: 0;
        top: 0;
        bottom: 0;
        width: ${({ percent }) => percent}%;
    }
    &::after {
        content: '${({ percent }) => percent ? 'In Range' : 'Out of Range'}';
        position: relative;
        z-index: 1;
    }
`

const SelectButton = styled(Button) <{ selected: boolean, inRange?: boolean }>`
    background-color: ${({ selected, theme }) => selected ? theme.colors.primary : theme.colors.disabled};
    color: ${({ selected, inRange, theme }) => selected || inRange === undefined ? 'white' : inRange ? theme.colors.success : theme.colors.failure};
`

const ButtonWrapper = styled.div`
    position: relative;
`

const ButtonDropDown = styled(Box)`
    background: #332D3E;
    border-radius: 10px;
    position: absolute;
    right: 0;
    top: 100%;
    width: fit-content;
    padding: 4px;
    z-index: 1;
        & > div {
            padding: 4px 16px;
            cursor: pointer;
            white-space: nowrap;
            &:hover {
                background: ${({ theme }) => theme.colors.primary};
                border-radius: 8px;
            }
        }
`

const Icon = ({ color, size }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.99996 12.3337V8.33366M8.99996 6.33366V6.32699M16.3333 9.00033C16.3333 13.0504 13.05 16.3337 8.99996 16.3337C4.94987 16.3337 1.66663 13.0504 1.66663 9.00033C1.66663 4.95024 4.94987 1.66699 8.99996 1.66699C13.05 1.66699 16.3333 4.95024 16.3333 9.00033Z" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
        </svg>
    );
}

const ClaimButtonBox = ({ onClickItem, ...props }: ButtonProps & { onClickItem: (item: string) => void }) => {
    const { t } = useTranslation()
    const [showDropDown, setDropDown] = useState(false)
    const [targetRef, setTargetRef] = useState<HTMLDivElement | null>(null)
    useOnClickOutside(
        targetRef,
        useCallback(() => {
            setDropDown(false);
        }, [setDropDown])
    )
    return <ButtonWrapper ref={setTargetRef}>
        <Button {...props} onClick={(e) => {
            e.stopPropagation()
            setDropDown(!showDropDown)
        }}>
            Claim
            {/* <Flex width={["40px", "60px", "72px"]} borderLeft="1px solid #FFFFFF26" ml="auto" alignItems="center" justifyContent="center">
				<ChevronDownIcon width={24} />
			</Flex> */}
        </Button>
        {
            showDropDown &&
            <ButtonDropDown>
                <Box onClick={(e) => {
                    e.stopPropagation()
                    onClickItem("unstaked")
                }}>
                    <Text fontSize={14}>{t("from Unstaked positions")}</Text>
                </Box>
                <Box onClick={(e) => {
                    e.stopPropagation()
                    onClickItem("staked")
                }}>
                    <Text fontSize={14}>{t("from Staked positions")}</Text>
                </Box>
            </ButtonDropDown>
        }
    </ButtonWrapper>
}

const V3Position = React.memo(({ pool, positions, expanded, setExpanded }: { pool: PoolData, positions: PositionData[], expanded: boolean, setExpanded: (exp: boolean) => void }) => {
    const { t } = useTranslation()
    const { account, chainId } = useAccountActiveChain()
    const currency0 = useCurrency(pool.token0?.address)
    const currency1 = useCurrency(pool.token1?.address)
    const [tokenId, setTokenId] = useState<number>()

    const [stakeTxHash, setStakeTxHash] = useState<string>("")
    const [unstakeTxHash, setUnstakeTxHash] = useState<string>("")
    const [isStakePending, setIsStakePending] = useState(false)
    const [isUnstakePending, setIsUnstakePending] = useState(false)

    const [attemptingTxn, setAttemptingTxn] = useState(false)

    const publicClient = usePublicClient()

    const { isMobile, isTablet } = useMatchBreakpoints()

    const [, poolv3] = usePool(pool.token0, pool.token1, pool.feeTier * 10000)

    const ticksAtLimit = {
        [Bound.LOWER]: false, [Bound.UPPER]: false
    }

    const unstakedPositions = useMemo(() => positions.filter(p => !p.staked), [positions])
    const stakedPositions = useMemo(() => positions.filter(p => p.staked), [positions])

    const pivotPosition = useMemo(() => tokenId !== undefined ? positions[tokenId] : positions[0], [positions, tokenId])

    const blockNumber = useCurrentBlock()

    const totalPoints = useMemo(() => {
        return positions.reduce((total, p) => total + (p.staked && p.staked.block ? (p.staked.points + p.staked.amount * (blockNumber - p.staked.block)) * REWARD_RATIO : 0), 0)
    }, [positions, blockNumber])

    const price = poolv3?.priceOf(pool.token0)

    const priceLower = tokenId !== undefined ? tickToPrice(pool.token0, pool.token1, pivotPosition.tickLower) : undefined
    const priceUpper = tokenId !== undefined ? tickToPrice(pool.token0, pool.token1, pivotPosition.tickUpper) : undefined

    const poolStats = usePoolData(pool.address.toLowerCase())

    const [priceLow24H, priceHigh24H] = useMemo(() => {
        if (poolStats) {
            const priceLow = tryParsePrice(currency1?.wrapped, currency0?.wrapped, String(poolStats.token0PriceLow24H))
            const priceHigh = tryParsePrice(currency1?.wrapped, currency0?.wrapped, String(poolStats.token0PriceHigh24H))
            return [priceLow, priceHigh]
        }
        return [undefined, undefined]
    }, [poolStats, currency0, currency1])

    const zoomLevel = useMemo(() => {
        if (price && priceLower && priceUpper)
            return {
                initialMin: Math.max(0, Number(priceLower.toFixed(8)) / Number(price.toFixed(8)) - 0.1),
                initialMax: Math.max(0, Number(priceUpper.toFixed(8)) / Number(price.toFixed(8)) + 0.1),
                min: Number(priceLower.toFixed()),
                max: Number(priceUpper.toFixed()),
            } as ZoomLevels
        return ZOOM_LEVELS[pool.feeTier * 10000]
    }, [price, priceUpper, priceLower, pool])

    const {
        isLoading: isChartDataLoading,
        // error: chartDataError,
        dataLevels,
        formattedData,
    } = useDensityChartData({
        currencyA: pool.token0,
        currencyB: pool.token1,
        feeAmount: pool.feeTier * 10000,
    })

    const normalize = useCallback((liquidity: bigint) => {
        if (!dataLevels)
            return 0
        let activeLiquidity = dataLevels[String(liquidity)]
        if (!activeLiquidity) {
            const beforeD = Object.keys(dataLevels).findLast(d => BigInt(d) < liquidity)
            const afterD = Object.keys(dataLevels).find(d => BigInt(d) > liquidity)
            activeLiquidity = (dataLevels[beforeD] ?? 0) + ((dataLevels[afterD] ?? 0) - (dataLevels[beforeD] ?? 0)) * (Number(liquidity) - Number(beforeD ?? 0)) / (Number(afterD ?? 0) - Number(beforeD ?? 0))
            // console.log('formattedData', dataLevels, position.liquidity, beforeD, afterD, activeLiquidity)
        }
        return Math.max(activeLiquidity, 2, Math.min(...Object.values(dataLevels).map(v => Number(v))))
    }, [dataLevels])

    const pivotFormattedData = useMemo(() => {
        if (!pivotPosition)
            return []

        if (tokenId === undefined && positions.length > 1) {
            return formattedData
        }
        const activeLiquidity = normalize(pivotPosition.liquidity)
        return [
            { activeLiquidity, price0: Number(tickToPrice(pool.token0, pool.token1, pivotPosition.tickLower).toSignificant(8)) },
            { activeLiquidity, price0: Number(tickToPrice(pool.token0, pool.token1, pivotPosition.tickUpper).toSignificant(8)) },
        ] as ChartEntry[]
    }, [tokenId, formattedData, pivotPosition, positions, normalize, pool])

    // const totalLiquidity = positions.filter((p, i) => tokenId === undefined || i === tokenId).reduce((summary, position) => summary + position.liquidity, 0n)

    const { token0Deposited, token1Deposited, token0USDValue, token1USDValue } = useMemo(() =>
        positions.filter((p, i) => tokenId === undefined || i === tokenId).reduce((summary, position) => ({
            token0Deposited: summary.token0Deposited + position.liquidityToken0,
            token1Deposited: summary.token1Deposited + position.liquidityToken1,
            token0USDValue: summary.token0USDValue + position.token0USD,
            token1USDValue: summary.token1USDValue + position.token1USD,
        }), {
            token0Deposited: 0,
            token1Deposited: 0,
            token0USDValue: 0,
            token1USDValue: 0,
        }),
        [positions, tokenId]
    )

    const { feeToken0, feeToken1, fee0USD, fee1USD, feeUSD } = useMemo(() =>
        positions.reduce((summary, position) => ({
            feeToken0: summary.feeToken0 + position.feeToken0,
            feeToken1: summary.feeToken1 + position.feeToken1,
            fee0USD: summary.fee0USD + position.fee0USD,
            fee1USD: summary.fee1USD + position.fee1USD,
            feeUSD: summary.feeUSD + position.fee0USD + position.fee1USD,
        }), {
            feeToken0: 0, feeToken1: 0, fee0USD: 0, fee1USD: 0, feeUSD: 0,
        }),
        [positions]
    )

    const inRange = (p: PositionData) => p.tick >= p.tickLower && p.tick <= p.tickUpper

    // const liquidityOfPool = useMemo(() => positions.filter(inRange).reduce((summary, position) => summary + position.liquidity, 0n), [positions])
    const share = useMemo(() => positions.reduce((summary, position) => summary + position.share, 0), [positions])

    const positionManager = useV3NFTPositionManagerContract()

    const { fetchTxResponse } = useCatchTxError()

    useEffect(() => {
        if (stakeTxHash === "")
            return
        setIsStakePending(true)
        publicClient.waitForTransactionReceipt(
            { hash: stakeTxHash as `0x${string}`, confirmations: 1 },
        ).then(async (transaction) => {
            setIsStakePending(false)
        }).catch(e => {
            setIsStakePending(false)
        }).finally(() => {
            setStakeTxHash("")
            setIsStakePending(false)
        })
    }, [publicClient, stakeTxHash])

    useEffect(() => {
        if (unstakeTxHash === "")
            return
        setIsUnstakePending(true)
        publicClient.waitForTransactionReceipt(
            { hash: unstakeTxHash as `0x${string}`, confirmations: 1 },
        ).then(async (transaction) => {
            setIsUnstakePending(false)
        }).catch(e => {
            setIsUnstakePending(false)
        }).finally(() => {
            setUnstakeTxHash("")
            setIsUnstakePending(false)
        })

    }, [publicClient, unstakeTxHash])

    const onClaim = async () => {
        const options = {}
        setAttemptingTxn(true)
        const feeAmounts = await Promise.all(positions.map(p =>
            positionManager.simulate.collect([
                {
                    tokenId: p.tokenId,
                    recipient: account, // some tokens might fail if transferred to address(0)
                    amount0Max: MaxUint128,
                    amount1Max: MaxUint128,
                },
            ], { account })
                .then(results => results.result)
                .catch(() => [0n, 0n])
        ))
        const calldata = positions.flatMap((p, i) => {
            const [fee0, fee1] = feeAmounts[i]
            if (fee0 === 0n && fee1 === 0n)
                return undefined
            const involvesETH = currency0.isNative || currency1.isNative
            const calldatas = []

            calldatas.push(
                encodeFunctionData({
                    abi: NonfungiblePositionManager.ABI,
                    functionName: 'collect',
                    args: [
                        {
                            tokenId: p.tokenId,
                            recipient: involvesETH ? ADDRESS_ZERO : account,
                            amount0Max: MaxUint128,
                            amount1Max: MaxUint128,
                        },
                    ],
                })
            )

            if (involvesETH) {
                if (fee0 > 0n) {
                    if (currency0.isNative)
                        calldatas.push(Payments.encodeUnwrapWETH9(fee0, account))
                    else
                        calldatas.push(Payments.encodeSweepToken(currency0.wrapped, fee0, account))
                }
                if (fee1 > 0n) {
                    if (currency1.isNative)
                        calldatas.push(Payments.encodeUnwrapWETH9(fee1, account))
                    else
                        calldatas.push(Payments.encodeSweepToken(currency1.wrapped, fee1, account))
                }
            }
            return calldatas
        }).filter(Boolean)
        if (calldata.length) {
            positionManager.estimateGas.multicall([calldata], {}).then(gas =>
                fetchTxResponse(() =>
                    positionManager.write.multicall(
                        [calldata],
                        { ...options, fee: calculateGasMargin(gas) }
                    ), {
                    summary: "Claimed",
                    translatableSummary: {
                        text: 'Claimed %amount0% %symbol0% and %amount1% %symbol1%',
                        data: {
                            amount0: feeToken0.toFixed(2),
                            symbol0: currency0.symbol,
                            amount1: feeToken1.toFixed(2),
                            symbol1: currency1.symbol,
                        },
                    },
                    type: 'claim',
                }
                ).finally(() => {
                    setAttemptingTxn(false)
                })
            ).catch(() => setAttemptingTxn(false))
        } else {
            setAttemptingTxn(false)
        }
    }

    const [onPresentIncreaseModal] = useModal(
        <IncreaseModal
            key={`increase-modal-${pool.address}`}
            currencyA={currency0}
            currencyB={currency1}
            position={
                pivotPosition && poolv3 && (positions.length === 1 || tokenId !== undefined)
                    ? new Position({
                        pool: poolv3,
                        liquidity: pivotPosition?.liquidity,
                        tickLower: pivotPosition?.tickLower,
                        tickUpper: pivotPosition?.tickUpper,
                    })
                    : undefined
            }
            poolData={pool}
        />,
        true,
        false,
        `increase-v3-liquidity-${pool.address}`
    )

    const [onPresentDecreaseModal] = useModal(
        <DecreaseModal
            key={`decrease-modal-${pool.address}`}
            currencyA={currency0}
            currencyB={currency1}
            positions={unstakedPositions}
            poolData={pool}
        />,
        true,
        false,
        `decrease-v3-liquidity-${pool.address}`
    )

    const [onPresentStakeModal] = useModal(
        <StakeModal
            key={`stake-modal-${pool.address}`}
            currencyA={currency0}
            currencyB={currency1}
            positions={unstakedPositions.filter(inRange)}
            poolData={pool}
            setStakeTxHash={setStakeTxHash}
        />,
        true, // unstakedPositions.filter(inRange).length > 1,
        false,
        `stake-v3-position-${pool.address}`
    )

    const [onPresentUnstakeModal] = useModal(
        <UnstakeModal
            key={`unstake-modal-${pool.address}`}
            currencyA={currency0}
            currencyB={currency1}
            positions={stakedPositions}
            poolData={pool}
            setUnstakeTxHash={setUnstakeTxHash}
        />,
        true,
        false,
        `stake-v3-position-${pool.address}`
    )

    const [onPresentConfirmModal] = useModal(
        <TransactionConfirmationModal
            minWidth={['100%', null, '420px']}
            title={t('Collect Fee')}
            // customOnDismiss={}
            attemptingTxn={attemptingTxn}
            hash={''}
            content={() => null}
            pendingText={t("Claim %amount0% %symbol0% and %amount1% %symbol1%", {
                amount0: feeToken0.toFixed(2),
                symbol0: currency0?.symbol,
                amount1: feeToken1.toFixed(2),
                symbol1: currency1?.symbol,
            })}
        />,
        false,
        true,
        `modal-fee-collect-${pool.address}`,
    )

    const handleClaim = () => {
        onPresentConfirmModal()
        onClaim()
    }

    const handleStake = (e: any) => {
        e.stopPropagation()
        onPresentStakeModal()
    }

    const handleUnstake = (e: any) => {
        e.stopPropagation()
        onPresentUnstakeModal()
    }

    const { targetRef: tvlRef, tooltip: tvlTooltip, tooltipVisible: tvlVisible } = useTooltip(
        <Text color="textSubtle" fontSize={12}>
            {t('Across multiple positions')}
        </Text>,
        {
            placement: 'top',
            trigger: 'hover',
        },
    )

    const { targetRef: cannotStakeRef, tooltip: cannotStakeTooltip, tooltipVisible: cannotStakeVisible } = useTooltip(
        <Text color="textSubtle" fontSize={12}>
            {t('Only Active / In range positions can be staked to earn points')}
        </Text>,
        {
            placement: 'top',
            trigger: 'hover',
        },
    );

    return (
        <Panel>
            <FlexGap style={{ cursor: "pointer" }} onClick={() => setExpanded(!expanded)} alignItems="center" gap="8px" alignSelf="stretch">
                <FlexGap alignItems="center" gap="8px" flexWrap="wrap">
                    <DoubleCurrencyLogo currency0={currency0} currency1={currency1} size={24} />
                    <Text fontSize="18px">{currency0?.symbol} - {currency1?.symbol}</Text>
                    <FeeTier>{pool.feeTier}%</FeeTier>
                    <FlexGap gap="8px" flex={1}>
                        <InRange percent={positions.filter(inRange).length * 100 / positions.length} />
                        {
                            positions.length > 1 &&
                            <Mark>{positions.length} Positions</Mark>
                        }
                    </FlexGap>
                </FlexGap>
                {
                    expanded
                        ? <ChevronUpIcon color="textSubtle" ml="auto" width={28} onClick={(e: any) => {
                            e.stopPropagation()
                            setExpanded(false)
                        }} />
                        : <ChevronDownIcon color="textSubtle" ml="auto" width={28} />
                }
            </FlexGap>
            <FlexGap style={{ cursor: "pointer" }} gap="8px" flexDirection="column" mt={3} onClick={() => setExpanded(!expanded)}>
                {
                    !expanded &&
                    <>
                        <Flex flexDirection={["column", "row", "row"]} alignItems={["stretch", "center", "center"]} justifyContent="space-between">
                            <Text ref={tvlRef} fontSize={14}>{t("Total Value")}</Text>
                            {
                                tvlVisible && tvlTooltip
                            }
                            <FlexGap gap="8px" alignItems="center" justifyContent="flex-end">
                                <Balance fontSize={16} value={token0USDValue + token1USDValue} prefix="$" decimals={2} />
                                <QuestionHelper placement="top"
                                    icon={<Icon color="#B99BF4" size={16} />}
                                    text={
                                        <FlexGap flexDirection="column" gap="8px">
                                            <Text color="textSubtle" fontSize={12}>{t('Positions')}</Text>
                                            {
                                                positions.map((p, i) =>
                                                    <Text key={`position-${p.tokenId}`} color="textSubtle" fontSize={12}>{t(`#${p.tokenId}`)}</Text>
                                                )
                                            }
                                        </FlexGap>
                                    }
                                />
                                {
                                    pool.farm &&
                                    <Box ref={cannotStakeRef}>
                                        <Button onClick={handleStake} scale="sm" disabled={isStakePending || !unstakedPositions.some(inRange) || attemptingTxn} style={{ fontSize: '14px', borderRadius: '8px' }}>
                                            {t("Stake")}
                                        </Button>
                                        {
                                            !unstakedPositions.some(inRange) && cannotStakeVisible && cannotStakeTooltip
                                        }
                                    </Box>
                                }
                            </FlexGap>
                        </Flex>
                    </>
                    // <>
                    //     <Flex flexDirection={["column", "row", "row"]} alignItems={["stretch", "center", "center"]} justifyContent="space-between">
                    //         <Text fontSize={14}>{t("Total Value")}</Text>
                    //         <FlexGap gap="8px" alignItems="center" justifyContent="flex-end">
                    //             <Balance fontSize={16} value={token0USDValue + token1USDValue} prefix="$" decimals={2} />
                    //             {
                    //                 pool.farm &&
                    //                 <Box ref={cannotStakeRef}>
                    //                     <Button onClick={handleStake} scale="sm" disabled={isStakePending || !unstakedPositions.some(inRange) || attemptingTxn} style={{ fontSize: '14px', borderRadius: '8px' }}>
                    //                         {t("Stake")}
                    //                     </Button>
                    //                     {/* <Button onClick={handleStake} scale="sm" disabled={isStakePending || !unstakedPositions.some(inRange) || attemptingTxn} style={{ fontSize: '14px', borderRadius: '8px' }}>
                    //                         {t("Stake")}
                    //                     </Button> */}
                    //                     {
                    //                         !unstakedPositions.some(inRange) && cannotStakeVisible && cannotStakeTooltip
                    //                     }
                    //                 </Box>
                    //             }
                    //         </FlexGap>
                    //     </Flex>
                    // </>
                }
                {
                    <>
                        <Flex flexDirection={["column", "row", "row"]} alignItems={["stretch", "center", "center"]} justifyContent="space-between">
                            <Text fontSize={14}>{t("Claimable Fees")}</Text>
                            <FlexGap gap="8px" alignItems="center">
                                <Balance fontSize={16} value={feeUSD} prefix="$" decimals={2} />
                                <QuestionHelper placement="top"
                                    icon={<Icon color="#B99BF4" size={16} />}
                                    text={
                                        feeUSD > 0
                                            ? <FlexGap flexDirection="column" gap="8px">
                                                <Text color="textSubtle" fontSize={12}>{t('Trading fees')}</Text>
                                                {
                                                    (fee0USD >= 0.01 || feeToken0 >= 0.01) &&
                                                    <Box style={{ display: 'grid', gridTemplateColumns: '24px 1fr 1fr 1fr', alignItems: 'center', gap: '8px' }}>
                                                        <CurrencyLogo currency={currency0} />
                                                        <Text fontSize={14}>{currency0?.symbol}</Text>
                                                        <Balance value={feeToken0} fontSize={14} ellipsis ml="auto" decimals={2} />
                                                        <Balance value={fee0USD} fontSize={14} prefix="$" decimals={2} />
                                                    </Box>
                                                }
                                                {
                                                    (fee1USD >= 0.01 || feeToken1 >= 0.01) &&
                                                    <Box style={{ display: 'grid', gridTemplateColumns: '24px 1fr 1fr 1fr', alignItems: 'center', gap: '8px' }}>
                                                        <CurrencyLogo currency={currency1} />
                                                        <Text fontSize={14}>{currency1?.symbol}</Text>
                                                        <Balance value={feeToken1} fontSize={14} ellipsis ml="auto" decimals={2} />
                                                        <Balance value={fee1USD} fontSize={14} prefix="$" decimals={2} />
                                                    </Box>
                                                }
                                            </FlexGap>
                                            : <Text color="textSubtle" fontSize={12}>{t('No trading fees')}</Text>
                                    }
                                />
                                {
                                    feeUSD >= 0.01 &&
                                    <Button onClick={handleClaim} disabled={attemptingTxn} scale="sm" style={{ fontSize: '14px', borderRadius: '8px' }}>{t("Claim")}</Button>
                                }
                            </FlexGap>
                        </Flex>
                        {/* {
                            pool.farm &&
                            <Flex flexDirection={["column", "row", "row"]} alignItems={["stretch", "center", "center"]} justifyContent="space-between">
                                <Text fontSize={14}>{t("Staking Rewards")}</Text>
                                <FlexGap gap="8px" alignItems="center" justifyContent="flex-end">
                                    <Balance fontSize={14} value={totalPoints} decimals={1} />
                                    {
                                        positions.some((p, i) => p.staked) && !expanded &&
                                        <Button disabled={isUnstakePending} onClick={handleUnstake} scale="sm" style={{ fontSize: '14px', borderRadius: '8px', background: '#F66' }}>
                                            {t("Unstake")}
                                        </Button>
                                    }
                                </FlexGap>
                            </Flex>
                        } */}
                    </>
                }
            </FlexGap>
            {
                expanded &&
                <>
                    <Flex alignItems="center" justifyContent="space-between" mt="8px">
                        <Text fontSize={14}>{t("Total Value")}</Text>
                        <Balance fontSize={14} value={token0USDValue + token1USDValue} prefix="~ $" decimals={2} />
                    </Flex>
                    <Hr />
                    {
                        positions.length > 1 &&
                        <FlexGap gap="8px">
                            <Text fontSize={14}>{t("Positions: ")}</Text>
                            <SelectButton selected={tokenId === undefined} onClick={() => setTokenId(undefined)} scale="xs">{t("All")}</SelectButton>
                            {
                                positions.map((p, i) =>
                                    <SelectButton key={`token-${p.tokenId}`} selected={i === tokenId} onClick={() => setTokenId(i)} scale="xs" inRange={inRange(p)}>#{String(p.tokenId)} {p.staked !== undefined ? "STAKED" : ""}</SelectButton>
                                )
                            }
                        </FlexGap>
                    }
                    <LiquidityChartRangeInput
                        zoomLevel={zoomLevel}
                        key={pool.address}
                        currencyA={pool.token0}
                        currencyB={pool.token1}
                        feeAmount={pool.feeTier * 10000}
                        ticksAtLimit={ticksAtLimit}
                        price={price ? Number(price?.toSignificant(8)) : undefined}
                        // priceLow24H={priceLow24H ? parseFloat((!inverted ? priceHigh24H.invert() : priceLow24H).toSignificant(8)) : undefined}
                        // priceHigh24H={priceHigh24H ? parseFloat((!inverted ? priceLow24H.invert() : priceHigh24H).toSignificant(8)) : undefined}
                        priceLower={priceLower}
                        priceUpper={priceUpper}
                        formattedData={pivotFormattedData ?? []}
                        maxLiquidity={tokenId !== undefined && poolv3 ? Math.max(...Object.values(dataLevels).map(d => Number(d))) : undefined}
                        isLoading={isChartDataLoading}
                        dimensions={isMobile || isTablet ? { width: 320 } : {}}
                    />
                    <FlexGap gap="8px" justifyContent="center">
                        <Box borderRadius={4} bg="white" width={12} height={12} my={1} />
                        <Box>
                            <Text fontSize="12px" color="textSubtle">Current price</Text>
                            <Text fontSize="16px">{price?.toFixed(6)}</Text>
                            <Text fontSize="12px" color="textSubtle">{currency1?.symbol} per {currency0?.symbol}</Text>
                        </Box>
                        <Box width="10%" />
                        <Box borderRadius={4} bg="#B7ADD1" width={12} height={12} my={1} />
                        <Box>
                            <Text fontSize="12px" color="textSubtle">24H Price range</Text>
                            <Text fontSize="16px">{priceLow24H?.toFixed(6)} - {priceHigh24H?.toFixed(6)}</Text>
                            <Text fontSize="12px" color="textSubtle">{currency1?.symbol} per {currency0?.symbol}</Text>
                        </Box>
                    </FlexGap>
                    <Hr />
                    <Flex alignItems="center" justifyContent="space-between" mt={3}>
                        <Text fontSize={14} color="textSubtle">{t("APR")}</Text>
                        <Balance fontSize={14} value={pool.fee1d} unit="%" decimals={2} />
                    </Flex>
                    <FlexGap gap="8px" alignItems="center" mt={3}>
                        <CurrencyLogo currency={currency0} size="24px" />
                        <Text fontSize={14} color="textSubtle">{t("Pooled %symbol%", { symbol: currency0?.symbol })}</Text>
                        <Flex flexDirection="column" ml="auto">
                            <Balance fontSize={14} value={token0Deposited} ml="auto" decimals={4} />
                            <Balance fontSize={14} value={token0USDValue} prefix="$" color="textSubtle" decimals={2} textAlign="right" />
                        </Flex>
                    </FlexGap>
                    <FlexGap gap="8px" alignItems="center" mt={3}>
                        <CurrencyLogo currency={currency1} size="24px" />
                        <Text fontSize={14} color="textSubtle">{t("Pooled %symbol%", { symbol: currency1?.symbol })}</Text>
                        <Flex flexDirection="column" ml="auto">
                            <Balance fontSize={14} value={token1Deposited} ml="auto" decimals={4} />
                            <Balance fontSize={14} value={token1USDValue} prefix="$" color="textSubtle" decimals={2} textAlign="right" />
                        </Flex>
                    </FlexGap>
                    <Flex alignItems="center" justifyContent="space-between" mt={3}>
                        <Text fontSize={14} color="textSubtle">{t("Share in Pool")}</Text>
                        {
                            share
                                ? <Balance fontSize={14} value={share} unit="%" decimals={2} />
                                : <Text fontSize={14}>-</Text>
                        }
                    </Flex>
                    <FlexGap gap="8px" mt={3} justifyContent="space-between">
                        <Button width="100%" style={{ fontSize: "16px" }} onClick={onPresentIncreaseModal}>{t("Add")}</Button>
                        {unstakedPositions.some(Boolean) && <Button width="100%" style={{ fontSize: "16px", color: "white", backgroundColor: "#4C425F" }} onClick={onPresentDecreaseModal} variant="subtle">{t("Remove")}</Button>}
                    </FlexGap>
                    {
                        pool.farm &&
                        <>
                            <FlexGap gap="8px" mt={1} justifyContent="space-between">
                                {unstakedPositions.some(inRange) && (<Button width="100%" onClick={handleStake} variant="secondary" style={{ fontSize: '16px', color: 'white' }} mt={2}>{unstakedPositions.some(Boolean) ? t("Stake") : t("Stake and earn Points")}</Button>)}
                                {stakedPositions.some(Boolean) && (<Button width="100%" onClick={handleUnstake} variant="secondary" style={{ fontSize: '16px', color: 'white', borderColor: '#F66' }} mt={2}>{t("Unstake")}</Button>)}
                            </FlexGap>
                            <Text color="textSubtle" fontSize={12} mt={1} textAlign="center">
                                {t("(Your LP position still generates yield for you while staked!)")}
                            </Text>
                        </>
                    }
                </>
            }
        </Panel>
    )
})

export default V3Position